import React from 'react';

interface MainGoalCardProps {
  totalDays: number;
  completedDays: number;
}

const MainGoalCard: React.FC<MainGoalCardProps> = ({ totalDays, completedDays }) => {
  const progressPercentage = (completedDays / totalDays) * 100;

  return (
    <div className="bg-white/5 border-white/10 rounded-xl p-4 shadow-lg mb-6">
      <div className="flex items-center justify-between gap-4">
        <div className="flex-1">
          <h2 className="text-sm font-medium text-white mb-3">
            Complete as {totalDays} tarefas
          </h2>
          
          <div className="relative">
            {/* Barra de progresso */}
            <div className="h-2 bg-white/10 rounded-full overflow-hidden">
              <div
                className="h-full bg-luxury-gold transition-all duration-500 ease-out"
                style={{ width: `${progressPercentage}%` }}
              />
            </div>
            
            {/* Texto de progresso */}
            <div className="flex justify-end mt-1">
              <span className="text-xs font-medium text-white/60">
                {completedDays} / {totalDays}
              </span>
            </div>
          </div>
        </div>
        
        {/* Ícone de troféu */}
        <div className="flex-shrink-0">
          <div className="w-12 h-12 bg-luxury-gold/20 rounded-full flex items-center justify-center">
            <span className="text-2xl">🏆</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainGoalCard;
